import { render, staticRenderFns } from "./Topup.vue?vue&type=template&id=228bc20f&scoped=true"
import script from "./Topup.vue?vue&type=script&lang=ts"
export * from "./Topup.vue?vue&type=script&lang=ts"
import style0 from "./Topup.vue?vue&type=style&index=0&id=228bc20f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228bc20f",
  null
  
)

export default component.exports